import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { useData } from "@/context/DataContext";
import { rangoPeriodo, eur } from "@/lib/gastos";

// Acceso a Gastos desde Inicio con el total del mes.
export const GastosInicio = () => {
  const navigate = useNavigate();
  const { gastos = [] } = useData();
  const mes = rangoPeriodo("mes");
  const delMes = gastos.filter((g) => g.fecha >= mes.desde && g.fecha <= mes.hasta);
  const total = delMes.reduce((s, g) => s + g.importe, 0);
  const totalTodo = gastos.reduce((s, g) => s + g.importe, 0);
  const n = (k) => `${k} ${k === 1 ? "gasto" : "gastos"}`;
  return (
    <section className="space-y-2" data-testid="home-gastos">
      <h2 className="font-heading text-xl font-bold text-[#1C2421]">¿Qué quieres revisar?</h2>
      <div className="grid grid-cols-[1fr_auto] gap-2.5">
        <button data-testid="home-gastos-abrir" onClick={() => navigate("/gastos")}
          className="bg-white border border-[#E5DFD5] rounded-2xl p-4 flex items-center gap-3 text-left hover:border-[#3A6B56] min-h-[76px]">
          <span className="w-12 h-12 rounded-xl bg-[#E8F0EC] flex items-center justify-center shrink-0"><Icons.Receipt size={24} className="text-[#3A6B56]" /></span>
          <span className="min-w-0">
            <span className="block font-heading font-bold text-lg text-[#1C2421]">Gastos</span>
            <span className="block text-sm text-[#4A5550]" data-testid="home-gastos-total">Este mes: {eur(total)} · {n(delMes.length)}</span>
            {gastos.length > delMes.length && <span className="block text-sm font-semibold text-[#1C2421]" data-testid="home-gastos-registrado">Total registrado: {eur(totalTodo)} · {n(gastos.length)}</span>}
          </span>
        </button>
        <button data-testid="home-gastos-registrar" onClick={() => navigate("/gastos?registrar=1")} aria-label="Registrar un gasto"
          className="w-[76px] rounded-2xl bg-[#3A6B56] text-white flex flex-col items-center justify-center gap-1 text-xs font-semibold">
          <Icons.Camera size={24} /> Registrar
        </button>
        <button data-testid="area-ocio" onClick={() => navigate("/ocio")}
          className="bg-white border border-[#E5DFD5] rounded-2xl p-4 flex items-center gap-3 text-left hover:border-[#3A6B56] min-h-[76px]">
          <span className="w-12 h-12 rounded-xl bg-[#E8F0EC] flex items-center justify-center shrink-0"><Icons.Ticket size={24} className="text-[#3A6B56]" /></span>
          <span className="block font-heading font-bold text-lg text-[#1C2421]">Ocio y Reservas</span>
        </button>
        <button data-testid="home-ocio-anadir" onClick={() => navigate("/ocio?nuevo=1")} aria-label="Añadir entrada o reserva"
          className="w-[76px] rounded-2xl bg-[#3A6B56] text-white flex flex-col items-center justify-center gap-1 text-xs font-semibold">
          <Icons.Plus size={24} /> Añadir
        </button>
      </div>
    </section>
  );
};
